// @react/hooks/useBillingUsage.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { billingUsageStore } from '@core/stores';

/**
 * React hook for UsageRecord operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useBillingUsage } from '@react/hooks';
 *
 * const UsageRecordList = observer(() => {
 *   const store = useBillingUsage();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useBillingUsage() {
  return billingUsageStore;
}
